import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button, Box, Typography } from '@mui/material';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'true');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 glass-effect border-t border-cyan/10"
        >
          <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <Typography variant="body2" className="text-cyan-light/70 text-sm text-center sm:text-left">
              We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
            </Typography>
            <div className="flex gap-3">
              <Button
                variant="outlined"
                size="small"
                onClick={acceptCookies}
                sx={{
                  borderColor: 'rgba(79,195,247,0.3)',
                  color: '#4fc3f7',
                  '&:hover': {
                    borderColor: '#4fc3f7',
                    background: 'rgba(79,195,247,0.05)',
                  },
                }}
              >
                Learn More
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={acceptCookies}
                sx={{
                  background: 'linear-gradient(135deg, #0288d1 0%, #4fc3f7 100%)',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              >
                Accept
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
